export default {
  'return-to-bucket-list': 'バケット一覧に戻る',
  'returns-to-the-input-screen': '入力画面に戻る',
  'check-cooperation': '連携確認する',
  'cooperate': '連携する',
}
